// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Inspections page styles */
.inspections-table-wrapper {
  overflow-x: auto;
}

.inspections-table {
  width: 100%;
  border-collapse: collapse;
  background: #2f3136;
  border-radius: 8px;
  overflow: hidden;
}

.inspections-table thead {
  background: #202225;
}

.inspections-table th {
  padding: 12px 15px;
  text-align: left;
  color: #b9bbbe;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
}

.inspections-table td {
  padding: 12px 15px;
  color: #dcddde;
  font-size: 14px;
  border-top: 1px solid #40444b;
}

.inspections-table tbody tr:hover {
  background: #36393f;
}

.status-badge.pending { background: #faa61a; color: black; }
.status-badge.submitted { background: #5865f2; color: white; }
.status-badge.reviewed { background: #43b581; color: white; }
.status-badge.passed { background: #43b581; color: white; }
.status-badge.failed { background: #f04747; color: white; }

.type-cell {
  text-transform: capitalize;
}

.instructions-cell {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.inspection-info {
  background: #2f3136;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 15px;
}

.inspection-info p {
  color: #b9bbbe;
  margin: 5px 0;
  font-size: 13px;
}

.inspection-info strong {
  color: #dcddde;
}

.table-actions {
  display: flex;
  gap: 6px;
}

.action-btn.submit {
  background: #5865f2;
  color: white;
}

.action-btn.review {
  background: #faa61a;
  color: black;
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background: #40444b;
  outline: none;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #5865f2;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #5865f2;
  cursor: pointer;
  border: none;
}

.no-data {
  text-align: center;
  color: #72767d;
  padding: 40px;
}

/* Shared styles */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.add-btn {
  background: #5865f2;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.add-btn:hover {
  background: #4752c4;
}

.filter-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.filter-tabs button {
  background: #2f3136;
  color: #b9bbbe;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.filter-tabs button.active,
.filter-tabs button:hover {
  background: #5865f2;
  color: white;
}

.status-badge {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 11px;
}

.action-btn {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
}

.action-btn.delete {
  background: #f04747;
  color: white;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: #36393f;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal h2 {
  color: #fff;
  margin: 0 0 20px 0;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  color: #b9bbbe;
  margin-bottom: 5px;
  font-size: 13px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #40444b;
  border-radius: 4px;
  background: #2f3136;
  color: #fff;
  font-size: 14px;
}

.form-group textarea {
  min-height: 80px;
  resize: vertical;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn {
  padding: 10px 20px;
  background: #40444b;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn {
  padding: 10px 20px;
  background: #5865f2;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn:hover {
  background: #4752c4;
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #40444b;
  border-top-color: #5865f2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Inspections.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB,mBAAmB,EAAE,YAAY,EAAE;AAC3D,0BAA0B,mBAAmB,EAAE,YAAY,EAAE;AAC7D,yBAAyB,mBAAmB,EAAE,YAAY,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,YAAY,EAAE;AAC1D,uBAAuB,mBAAmB,EAAE,YAAY,EAAE;;AAE1D;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* Inspections page styles */\n.inspections-table-wrapper {\n  overflow-x: auto;\n}\n\n.inspections-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #2f3136;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.inspections-table thead {\n  background: #202225;\n}\n\n.inspections-table th {\n  padding: 12px 15px;\n  text-align: left;\n  color: #b9bbbe;\n  font-size: 12px;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.inspections-table td {\n  padding: 12px 15px;\n  color: #dcddde;\n  font-size: 14px;\n  border-top: 1px solid #40444b;\n}\n\n.inspections-table tbody tr:hover {\n  background: #36393f;\n}\n\n.status-badge.pending { background: #faa61a; color: black; }\n.status-badge.submitted { background: #5865f2; color: white; }\n.status-badge.reviewed { background: #43b581; color: white; }\n.status-badge.passed { background: #43b581; color: white; }\n.status-badge.failed { background: #f04747; color: white; }\n\n.type-cell {\n  text-transform: capitalize;\n}\n\n.instructions-cell {\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.inspection-info {\n  background: #2f3136;\n  border-radius: 8px;\n  padding: 12px;\n  margin-bottom: 15px;\n}\n\n.inspection-info p {\n  color: #b9bbbe;\n  margin: 5px 0;\n  font-size: 13px;\n}\n\n.inspection-info strong {\n  color: #dcddde;\n}\n\n.table-actions {\n  display: flex;\n  gap: 6px;\n}\n\n.action-btn.submit {\n  background: #5865f2;\n  color: white;\n}\n\n.action-btn.review {\n  background: #faa61a;\n  color: black;\n}\n\n.slider {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 8px;\n  border-radius: 4px;\n  background: #40444b;\n  outline: none;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #5865f2;\n  cursor: pointer;\n}\n\n.slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #5865f2;\n  cursor: pointer;\n  border: none;\n}\n\n.no-data {\n  text-align: center;\n  color: #72767d;\n  padding: 40px;\n}\n\n/* Shared styles */\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.add-btn {\n  background: #5865f2;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.add-btn:hover {\n  background: #4752c4;\n}\n\n.filter-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.filter-tabs button {\n  background: #2f3136;\n  color: #b9bbbe;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.filter-tabs button.active,\n.filter-tabs button:hover {\n  background: #5865f2;\n  color: white;\n}\n\n.status-badge {\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n}\n\n.action-btn {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n}\n\n.action-btn.delete {\n  background: #f04747;\n  color: white;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: #36393f;\n  border-radius: 8px;\n  padding: 20px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal h2 {\n  color: #fff;\n  margin: 0 0 20px 0;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  color: #b9bbbe;\n  margin-bottom: 5px;\n  font-size: 13px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #40444b;\n  border-radius: 4px;\n  background: #2f3136;\n  color: #fff;\n  font-size: 14px;\n}\n\n.form-group textarea {\n  min-height: 80px;\n  resize: vertical;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.cancel-btn {\n  padding: 10px 20px;\n  background: #40444b;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn {\n  padding: 10px 20px;\n  background: #5865f2;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn:hover {\n  background: #4752c4;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  padding: 40px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #40444b;\n  border-top-color: #5865f2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
